import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddChat, AttachmentMD5Request, AttachmentProcessingDetails, AttachmentProcessingResponse, ChatRequest, ChatResponse, DeleteDocumentDto, ExtractedMSGDOCX, FileFetchData, FileUploadDetails, GetDocumentDto, QuestionResponse, RenameChatDto, SharedChatAddDto, SharedChatDeleteDto, UploadResponse, UrlUploadRequest } from '../../models/rig-model/file-upload';
import { environment } from '../../../../environments/environment';
import { ChatHistoryDetail, UpdateExtractedRigFile, UserChatDetail } from '../../models/rig-model/user-chat-detail';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RigService {

    constructor(private http: HttpClient) { }
    private apiUrl = 'https://apis.finrege.com';

    getUrlOrFileFetchedData(token: any, data: UrlUploadRequest) {
        const pythonUrl = `${this.apiUrl}/extractdata`;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        });
        return this.http.post<UploadResponse>(pythonUrl, data, { headers });
    }

    attachmentProcessing(token: any, attachmentDetails: Array<AttachmentProcessingDetails>) {
        const pythonUrl = `${this.apiUrl}/chat_datapoint_model`;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        });
        return this.http.post<Array<AttachmentProcessingResponse>>(pythonUrl, attachmentDetails, { headers });
    }

    // chatResponse(token:any, chat:ChatRequest){
    //   const pythonUrl = `${this.apiUrl}/get_insights_stream`;
    //   let headers = new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${token}`
    //   });
    //   return this.http.post<any>(pythonUrl, chat, { headers});
    // }

    chatResponse(token: string, chat: any): Observable<any> {
        return new Observable(observer => {
            const pythonUrl = `${this.apiUrl}/get_insights_stream`;
            const xhr = new XMLHttpRequest();
            let lastProcessedIndex = 0;  // To track the last processed index of received text

            xhr.open('POST', pythonUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.onprogress = (event: any) => {
                const currentResponse = event.target.responseText;
                const endTagIndex = currentResponse.indexOf('<END_OF_RESPONSE>');

                if (endTagIndex !== -1) {
                    // Stream the text portion up to the <END_OF_RESPONSE>
                    const textContent = currentResponse.substring(lastProcessedIndex, endTagIndex);
                    observer.next({ type: 'text', data: textContent });

                    // Handle the JSON part
                    const jsonResponse = currentResponse.substring(endTagIndex + 17);
                    try {
                        const jsonData = JSON.parse(jsonResponse);
                        observer.next({ type: 'json', data: jsonData });
                        observer.complete();
                    } catch (e) {
                        observer.error('Failed to parse JSON data.');
                    }
                } else {
                    // Continuously update with received text
                    const newText = currentResponse.substring(lastProcessedIndex);
                    observer.next({ type: 'text', data: newText });
                    lastProcessedIndex = currentResponse.length;
                }
            };

            xhr.onerror = () => {
                observer.error('Failed to get the response.');
            };

            xhr.send(JSON.stringify(chat));
        });
    }



    getContextualQuestions(token: any, attachmentDetails: Array<AttachmentProcessingDetails>) {
        const pythonUrl = `${this.apiUrl}/get_contextual_questions`;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        });
        return this.http.post<QuestionResponse>(pythonUrl, attachmentDetails, { headers });
    }

    getAzureContainerName(sourceFolderName: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get<any>(`${environment.config.baseAppURL}/Rig/GetAzureContainerName?sourceFolderName=` + sourceFolderName, { headers });
    }

    getMsgDetails(documentName: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get<FileUploadDetails>(`${environment.config.baseAppURL}/Rig/GetUploadedRigDocumentDetails?documentName=` + documentName, { headers });
    }

    uploadRigFile(file: File, uuid: string, changeViewerId: string): Observable<ExtractedMSGDOCX> {
        const formData: FormData = new FormData();
        formData.append('file', file);
        formData.append('uuid', uuid);
        formData.append('ChangeViewerId', changeViewerId);
        return this.http.post<ExtractedMSGDOCX>(`${environment.config.baseAppURL}/Rig/UploadFileAsync`, formData);
    }

    getUserChatList(userExternalId: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');

        return this.http.get<any>(`${environment.config.baseAppURL}/Rig/GetUserChatList?userExternalId=` + userExternalId, { headers });
    }

    //Upload Extracted Rig File
    updateExtractedRigFile(uploadedDetails: UpdateExtractedRigFile): Observable<ChatHistoryDetail> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post<ChatHistoryDetail>(`${environment.config.baseAppURL}/Rig/UpdateExtractedRigFile`, uploadedDetails, { headers });
    }

    //Get User Chat Details after clicking one chat from sidebar
    getUserChatDetails(uUID: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get<any>(`${environment.config.baseAppURL}/Rig/GetUserChatDetails?uUID=${uUID}&changeViewerId=123`, { headers });
    }

    // Optional: Handle errors
    private handleError(error: any): Observable<any> {
        console.error('API Error:', error);
        throw error; // You can customize error handling based on your needs
    }

    //Rig Work
    //Start
    // Method to upload a file

    getDocument(documentDetails: GetDocumentDto): Observable<Blob> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(`${environment.config.baseAppURL}/Rig/GetUploadedRigDocument`, documentDetails,
        { headers, responseType: 'blob' });
    }

    deleteExistingDocument(deleteDocument: DeleteDocumentDto): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers
            .set('Content-Type', 'application/json; charset=utf-8')
            .set('request', JSON.stringify(deleteDocument));
        return this.http.get<any>(
            `${environment.config.baseAppURL}/Rig/DeleteExistingDocument`,
            { headers }
        );
    }

    //End

    addOrUpdateChat(chat: AddChat) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post<any>(`${environment.config.baseAppURL}/Rig/AddOrUpdateChat`, chat, { headers });
    }
    getUserChangeViewerChatDetails(uxId?: string, changeViewerId?: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get<any>(`${environment.config.baseAppURL}/Rig/GetUserChangeViewerChatDetails?UXId=${uxId}&ChangeViewerId=${changeViewerId}`, { headers });
    }
 deleteChat(uuid:string){
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Rig/DeleteChat?uuid=`+uuid, { headers });
  }

  renameChat(renameChat:RenameChatDto){
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/Rig/RenameChat`, renameChat, { headers });
  }

  updateMd5InAttachment(
    attachmentRequest:AttachmentMD5Request
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/Rig/UpdateMd5InAttachment`,attachmentRequest,
      { headers }
    );
  }
  userDropdown():Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Rig/UserDropdownData`, { headers });
  }

  addSharedChat(sharedChat:SharedChatAddDto){
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${environment.config.baseAppURL}/Rig/AddSharedChat`, sharedChat, { headers });
  }
  getSharedChat(userId:string){
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Rig/GetSharedChatList?userId=`+userId, { headers });
  }
  deleteSharedChat(sharedChat:SharedChatDeleteDto){
    let headers = new HttpHeaders();
    headers = headers
            .set('Content-Type', 'application/json; charset=utf-8')
            .set('request', JSON.stringify(sharedChat));
    return this.http.get<any>(`${environment.config.baseAppURL}/Rig/DeleteSharedChat`, { headers });
  }
}